// Runtime config: prefer window.__env (injected by docker-entrypoint.sh)
// with fallback to process.env (build-time from .env file).
const env = (window.__env && window.__env.VUE_APP_DCH_API_URL)
  ? window.__env
  : process.env;

const config = {
  DCH_API_URL: env.VUE_APP_DCH_API_URL,
  PLATFORM_API_URL: env.VUE_APP_PLATFORM_API_URL,
  PLATFORM_URL: env.VUE_APP_PLATFORM_URL,
  API_DOCS_URL: env.VUE_APP_API_DOCS_URL,
  MAPBOX_TOKEN: env.VUE_APP_MAPBOX_TOKEN,
  MAPBOX_USERNAME: env.VUE_APP_MAPBOX_USERNAME,
  MAPBOX_STYLEID: env.VUE_APP_MAPBOX_STYLEID,
  IS_DEMO: env.VUE_APP_IS_DEMO,
  ENV: env.VUE_APP_ENV,
  SEGMENT_TOKEN: env.VUE_APP_SEGMENT_TOKEN,
  SEGMENT_HASH_NAMESPACE: env.VUE_APP_SEGMENT_HASH_NAMESPACE,
  USE_ANALYTICS: env.VUE_APP_USE_ANALYTICS,
  ANKERI_AUTH_ENABLED: env.VUE_APP_ANKERI_AUTH_ENABLED === 'true',
  AUTH_CLIENT_ID: env.VUE_APP_AUTH_CLIENT_ID,
  AUTH_CLIENT_DOMAIN: env.VUE_APP_AUTH_CLIENT_DOMAIN,
};

export default config;
